{
  "comment": "The finale (spec §8; S25 owns): the roll call (one node per person and state; each ends on a plain reply and the UI plays them in order, rollCall.ts), the four askers, Voss's \"we both sold it\" (stipend.ts VOSS_NODES) and Kell's line when \"on the payroll\" is rebuilt. Node shape: src/story/schemas.ts commsNodeSchema (a speaker, 1–3 lines, 1–4 replies; \"Show [log]\" replies; a reply without next ends the conversation). Node ids are unique across every comms file. Voice: docs/story/drafts/2026-09-29-m7-voice-samples.md; never celebratory. Text placeholders until the naming and voice pass.",
  "nodes": [
    {
      "id": "finale.roll.reyes.ally",
      "speaker": "reyes",
      "lines": [
        "Watch is with you. I wrote your hull in the book tonight. In the column we keep for ours."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Thank you."
        }
      ]
    },
    {
      "id": "finale.roll.reyes.cool",
      "speaker": "reyes",
      "lines": [
        "I heard. I'm on the channel. That's all you get from me for now."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Understood."
        }
      ]
    },
    {
      "id": "finale.roll.reyes.cheques",
      "speaker": "reyes",
      "lines": [
        "You cashed her cheques first. I'll fly with you. I won't pretend I didn't read the ledger."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Fair."
        }
      ]
    },
    {
      "id": "finale.roll.reyes.hostile",
      "speaker": "kell",
      "lines": [
        "Reyes won't take my call. She's still got your name on a list, and it isn't the Watch book."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Understood."
        }
      ]
    },
    {
      "id": "finale.roll.reyes.absent",
      "speaker": "kell",
      "lines": [
        "No word from the Watch. Whatever you do next, you do it without them."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Understood."
        }
      ]
    },
    {
      "id": "finale.roll.okafor.aboard",
      "speaker": "okafor",
      "lines": [
        "I'm in your spare berth with a meter and thirty years of not using it. I'll say my name if anyone asks. Spell it right."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "I will."
        }
      ]
    },
    {
      "id": "finale.roll.okafor.safe",
      "speaker": "okafor",
      "lines": [
        "I'm on the relay. It needs a seal changed on the ninth. If they want me at a table, I can be there by the tenth."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Understood."
        }
      ]
    },
    {
      "id": "finale.roll.okafor.held",
      "speaker": "kell",
      "lines": [
        "Okafor's still in a Tethys cabin. They're calling it an internal review. He won't be at any table you set."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Understood."
        }
      ]
    },
    {
      "id": "finale.roll.okafor.absent",
      "speaker": "kell",
      "lines": [
        "The surveyor's not coming. You've got his paper, not his voice."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Understood."
        }
      ]
    },
    {
      "id": "finale.roll.kell.high",
      "speaker": "kell",
      "lines": [
        "I've got pilots who'll fly where I say this week. I'm saying you."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Thanks, Kell."
        }
      ]
    },
    {
      "id": "finale.roll.kell.wary",
      "speaker": "kell",
      "lines": [
        "I'll pass your word on. I won't put my name under it yet."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Understood."
        }
      ]
    },
    {
      "id": "finale.roll.kell.low",
      "speaker": "kell",
      "lines": [
        "You took their money twice. I'm on this channel because the Candle's still lit, not because of you."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Understood."
        }
      ]
    },
    {
      "id": "finale.roll.duarte",
      "speaker": "duarte",
      "lines": [
        "Registry desk, break-room line. I can sign an affidavit of custody for the minute. I'd rather sign it than read about it."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Sign it."
        }
      ]
    },
    {
      "id": "finale.roll.claim.2",
      "speaker": "kell",
      "lines": [
        "The queue claim went in on two names, yours and the one who filed it with you. Both are on the record."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Understood."
        }
      ]
    },
    {
      "id": "finale.roll.claim.3",
      "speaker": "kell",
      "lines": [
        "The Watch claim went in with help. The help is in the record too."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Understood."
        }
      ]
    },
    {
      "id": "finale.roll.claim.4",
      "speaker": "kell",
      "lines": [
        "The survey claim went in on a second filing. Whoever co-signed it is in this now."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Understood."
        }
      ]
    },
    {
      "id": "finale.roll.claim.5",
      "speaker": "kell",
      "lines": [
        "The settlement claim was filed with somebody else's stamp beside yours. They know what that costs."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Understood."
        }
      ]
    },
    {
      "id": "finale.ask.expose.duarte",
      "speaker": "duarte",
      "lines": [
        "The Charter Hub will hear it if somebody files it. A hearing reads what's in the bundle and nothing else.",
        "Bring the originals if you have them. Copies get questioned."
      ],
      "replies": [
        {
          "id": "file",
          "text": "I'll file it."
        },
        {
          "id": "later",
          "text": "Not yet."
        }
      ]
    },
    {
      "id": "finale.ask.expose.kell",
      "speaker": "kell",
      "lines": [
        "The Mutual Bulletin will run what you send. Nobody at the Hub has to agree first.",
        "A leak doesn't pass a ban. It makes somebody propose one."
      ],
      "replies": [
        {
          "id": "leak",
          "text": "Run it."
        },
        {
          "id": "later",
          "text": "Not yet."
        }
      ]
    },
    {
      "id": "finale.ask.blackmail.voss",
      "speaker": "voss",
      "lines": [
        "You've done the reading, so I'll be brief. Keep the papers. Send me one page, so I know you have them.",
        "A share of what comes through the gate, every day it stays open. That's an old arrangement. It's outlived better people than us."
      ],
      "replies": [
        {
          "id": "page",
          "text": "One page."
        },
        {
          "id": "both",
          "text": "You sold it.",
          "next": "finale.voss.both_sold"
        },
        {
          "id": "no",
          "text": "No."
        }
      ]
    },
    {
      "id": "finale.ask.guardians.reyes",
      "speaker": "reyes",
      "lines": [
        "Give the cell the file. Then fly with us. The book needs more than one hand.",
        "The Patrol will call you a raider. Patrol's called worse people that."
      ],
      "replies": [
        {
          "id": "fly",
          "text": "I'll fly."
        },
        {
          "id": "no",
          "text": "Not like this."
        }
      ]
    },
    {
      "id": "finale.ask.guardians.kell",
      "speaker": "kell",
      "lines": [
        "Reyes won't ask, so I will. The cell takes the file and the pilot who brings it.",
        "Your warrant won't come off for money. Know that going in."
      ],
      "replies": [
        {
          "id": "fly",
          "text": "I'm in."
        },
        {
          "id": "no",
          "text": "No."
        }
      ]
    },
    {
      "id": "finale.ask.sell.meridian",
      "speaker": "meridianCounsel",
      "lines": [
        "Meridian Counsel. We pay for documents, not for opinions. The fee is fixed; the transfer is final.",
        "You won't hear from us about what we do with them."
      ],
      "replies": [
        {
          "id": "sell",
          "text": "Name the account."
        },
        {
          "id": "no",
          "text": "Not for sale."
        }
      ]
    },
    {
      "id": "finale.voss.both_sold",
      "speaker": "voss",
      "lines": [
        "Your account shows tetherstone to Carrow. Fair price, every time. I don't hold it against you. I'd like you not to hold it against me.",
        "We both sold it. Only one of us has to explain it to a hearing."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Noted."
        }
      ]
    },
    {
      "id": "finale.voss.both_sold_corp",
      "speaker": "voss",
      "lines": [
        "Your company's haulers run tetherstone too, and they file on time. You're an institution now. Institutions pay for things they don't look at.",
        "We both sold it."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Noted."
        }
      ]
    },
    {
      "id": "finale.voss.clean",
      "speaker": "voss",
      "lines": [
        "No tetherstone on your account. Admirable. Your lease still comes due on the same day as everyone else's."
      ],
      "variants": {
        "owned": ["No tetherstone on your account. Admirable. Your hull's paid off. Your fuel still comes through Carrow, like everyone's."],
        "corporation": ["No tetherstone on your company's books. Admirable. Your haulers still fuel at Carrow, like everyone's."]
      },
      "replies": [
        {
          "id": "ok",
          "text": "Noted."
        }
      ]
    },
    {
      "id": "finale.voss.lawsuit",
      "speaker": "voss",
      "lines": [
        "My counsel will be in touch about the payments. It's nothing personal. It's a contract, and you signed it by taking the money."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Understood."
        }
      ]
    },
    {
      "id": "finale.payroll.rebuilt",
      "speaker": "kell",
      "lines": [
        "The archivist says your file holds now. I don't know what changed your mind. I don't need to.",
        "Anyone who wants that file will be calling."
      ],
      "replies": [
        {
          "id": "ok",
          "text": "Let them call."
        }
      ]
    }
  ]
}
